export default "__VITE_ASSET__EBr16_fW__"